import Login from "../components/auth/login/Login.tsx";
import AuthLayoutWithReCaptcha from "../components/layouts/AuthLayoutWithReCaptcha.tsx";
import { useAuth } from "../hooks/useAuth.tsx";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import FormWrapper from "../components/forms/FormWrapper.tsx";
import Button from "../components/buttons/Button.tsx";
import { ButtonSize, ButtonVariant } from "../types/button.ts";
import ButtonLink from "../components/buttons/ButtonLink.tsx";
import UtilsHelper from "../helpers/utilsHelper.ts";

const LoginPage = () => {
    const _authService = useAuth();
    const _navigate = useNavigate();
    const [isRegisterMode, setIsRegisterMode] = useState(false);
    useEffect(() => {
        if (_authService.isRefreshTokenAvailable)
            _navigate("/");
        UtilsHelper.changeWindowDocumentTitle("Logowanie");
    }, [_authService.isRefreshTokenAvailable]);
    return (
        <AuthLayoutWithReCaptcha>
            {!isRegisterMode &&
                <FormWrapper>
                    <h2 className={"text-3xl font-light mb-14 leading-10"}>
                        <span className={"font-bold"}>Zaloguj się</span>, aby uzyskać pełny dostęp do platformy</h2>
                    <Login />
                    <div className={"flex space-x-4 items-center mt-5 text-neutral-200"}>
                        <div className={"h-0.5 w-full bg-neutral-700 rounded-full"} />
                        <p>lub</p>
                        <div className={"h-0.5 w-full bg-neutral-700 rounded-full"} />
                    </div>
                    <Button variant={ButtonVariant.TERTIARY} size={ButtonSize.LARGE}
                        onClick={() => setIsRegisterMode(true)}
                        className={"py-2 mt-5 w-full bg-neutral-900 border-sky-500 hover:bg-neutral-700"}
                    >Utwórz konto</Button>
                </FormWrapper>
            }
            {isRegisterMode &&
                <FormWrapper>
                    <h2 className={"text-3xl font-light mb-6 leading-10"}>
                        <span className={"font-bold"}>Utwórz konto</span>, aby uzyskać dostęp do platformy</h2>
                    <div className={"h-0.5 w-full bg-neutral-700 rounded-lg mb-6"} />
                    <p>Aby utworzyć konto w serwisie, zaloguj się na swoje konto klienta na stronie <ButtonLink
                        to={import.meta.env.VITE_MIX_LINK_TO_LMS}
                        variant={ButtonVariant.SECONDARY}
                        targetType={"_blank"}
                        className={"text-base pl-0 pr-0 pt-0 pb-0 mr-1 text-sky-500"}>bok.beskidmedia.pl</ButtonLink>
                        (Biuro Obsługi Klienta), a następnie przejdź do zakładki Beskid Media GO.</p>
                    <ButtonLink
                        to={import.meta.env.VITE_MIX_LINK_TO_LMS}
                        variant={ButtonVariant.PRIMARY}
                        className={"inline-block text-lg w-full py-2 mt-6 ring-offset-neutral-900"}
                    >Przejdź na stronę BOK</ButtonLink>
                    <div className={"flex space-x-4 items-center mt-5 text-neutral-200"}>
                        <div className={"h-0.5 w-full bg-neutral-600 rounded-full"} />
                        <p>lub</p>
                        <div className={"h-0.5 w-full bg-neutral-600 rounded-full"} />
                    </div>
                    <Button
                        variant={ButtonVariant.TERTIARY}
                        size={ButtonSize.LARGE}
                        onClick={() => setIsRegisterMode(false)}
                        className={"py-2 mt-5 w-full bg-neutral-900 border-sky-500 hover:bg-neutral-700"}
                    >Zaloguj się</Button>
                </FormWrapper>
            }
        </AuthLayoutWithReCaptcha>
    );
};

export default LoginPage;